<template>
  <v-container fluid class="pa-0">
    <v-card
      class="maintenance-banner"
      @click="redirectToPackages"
      role="link"
      aria-label="Explore home maintenance packages"
      data-aos="fade-up"
      data-aos-duration="800"
    >
      <div class="accent-stripe" aria-hidden="true"></div>
      <div class="animated-gradient" aria-hidden="true"></div>
      <div class="floating-shapes" aria-hidden="true">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
      </div>

      <v-row no-gutters align="center" class="banner-content">
        <v-col cols="12" md="7" class="pa-8 pa-md-12">
          <div class="content-wrapper">
            <h1
              class="banner-title mb-4 animate-slide-up"
              data-aos="fade-right"
              data-aos-duration="600"
              data-aos-delay="100"
            >
              Professional Home
              <span class="accent-text gradient-text">Maintenance</span>
              Packages
            </h1>

            <p
              class="banner-subtitle mb-6 animate-slide-up delay-1"
              data-aos="fade-right"
              data-aos-duration="600"
              data-aos-delay="200"
            >
              Keep your home in perfect condition with our comprehensive
              maintenance solutions. Choose from flexible packages tailored to
              your needs.
            </p>

            <div
              class="features-grid mb-6 animate-slide-up delay-2"
              aria-hidden="false"
            >
              <div
                class="feature-item"
                v-for="(feature, index) in features"
                :key="index"
                data-aos="zoom-in"
                :data-aos-duration="500"
                :data-aos-delay="300 + index * 100"
              >
                <div class="">
                  <v-icon :style="{ color: accent }" class="mr-2">{{
                    feature.icon
                  }}</v-icon>
                </div>
                <span class="feature-text">{{ feature.text }}</span>
              </div>
            </div>

            <div
              class="actions-row animate-slide-up delay-3"
              data-aos="fade-up"
              data-aos-duration="600"
              data-aos-delay="700"
            >
              <v-btn
                x-large
                :style="{ backgroundColor: accent }"
                class="explore-btn glow-btn"
                elevation="4"
                dark
                @click.stop="redirectToPackages"
                aria-label="Explore packages"
              >
                <span class="btn-text">Explore Packages</span>
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>

              <v-btn
                text
                class="learn-btn"
                @click.stop="openLearnMore"
                aria-label="Learn more about packages"
              >
                Learn more
                <v-icon right small :style="{ color: accent }"
                  >mdi-information-outline</v-icon
                >
              </v-btn>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="5" class="pa-0 d-none d-md-block">
          <div data-aos="fade-up" data-aos-delay="200" class="visual-section">
            <div class="cards-stack">
              <div class="package-card card-animate">
                <div class="icon-glow">
                  <v-icon :style="{ color: '#FF6B35' }" size="40"
                    >mdi-home-outline</v-icon
                  >
                </div>
                <div class="card-content">
                  <div class="card-title">Sliver Package</div>
                  <div class="card-subtitle">Essential home care services</div>
                </div>
              </div>

              <div
                class="package-card card-animate featured-card"
                style="animation-delay: 0.2s"
                data-aos="fade-left"
                data-aos-duration="600"
                data-aos-delay="450"
              >
                <div class="icon-glow">
                  <v-icon :style="{ color: accent }" size="40"
                    >mdi-home-heart</v-icon
                  >
                </div>
                <div class="card-content">
                  <div class="card-title">Gold Package</div>
                  <div class="card-subtitle">
                    Complete protection & maintenance
                  </div>
                </div>
              </div>

              <div
                class="package-card card-animate"
                style="animation-delay: 0.3s"
                data-aos="fade-left"
                data-aos-duration="600"
                data-aos-delay="600"
              >
                <div class="icon-glow">
                  <v-icon :style="{ color: '#FF6B35' }" size="40"
                    >mdi-shield-home</v-icon
                  >
                </div>
                <div class="card-content">
                  <div class="card-title">Platinum Package</div>
                  <div class="card-subtitle">Ultimate service experience</div>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "HomeMaintenanceBanner",
  data() {
    return {
      accent: "#FF6B35",
      features: [
        { icon: "mdi-check-circle", text: "Regular Inspections" },
        { icon: "mdi-check-circle", text: "Priority Support" },
        { icon: "mdi-check-circle", text: "Expert Technicians" },
        { icon: "mdi-check-circle", text: "Flexible Scheduling" },
      ],
    };
  },

  methods: {
    redirectToPackages() {
      window.open("https://homemaintenance.ohyesworld.com/", "_blank");
    },
    openLearnMore() {
      window.open("https://homemaintenance.ohyesworld.com/#packages", "_blank");
    },
  },
};
</script>

<style scoped>
.maintenance-banner {
  position: relative;
  min-height: 420px;
  overflow: hidden;
}
@media (min-width: 1600px) {
  .maintenance-banner {
    max-width: 1900px; /* Your limit */
    margin: 0 auto;
    box-shadow: none !important;
    border: none !important;
    position: relative;
    display: flex; /* Center contents */
    justify-content: center;
    align-items: center;
    text-align: center; /* For text centering */
  }
}

.maintenance-banner:hover {
  transform: translateY(-4px);
}

.accent-stripe {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  border-radius: 0;
  z-index: 2;
  pointer-events: none;
  animation: stripeGlow 3s ease-in-out infinite;
}

.animated-gradient {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  animation: rotate 20s linear infinite;
  pointer-events: none;
  z-index: 0;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.floating-shapes {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}

.shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.1;
  filter: blur(40px);
}

.shape-1 {
  width: 250px;
  height: 250px;
  background: linear-gradient(135deg, #ff6b35, #ff8c5a);
  top: -80px;
  right: 10%;
  animation: float 15s ease-in-out infinite;
}

.shape-2 {
  width: 180px;
  height: 180px;
  background: linear-gradient(225deg, #ff6b35, #ff8c5a);
  bottom: -50px;
  left: 15%;
  animation: float 12s ease-in-out infinite reverse;
}

.shape-3 {
  width: 120px;
  height: 120px;
  background: linear-gradient(315deg, #ff6b35, #ff8c5a);
  top: 40%;
  right: 5%;
  animation: float 18s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0) translateX(0) scale(1);
  }
  33% {
    transform: translateY(-30px) translateX(20px) scale(1.1);
  }
  66% {
    transform: translateY(-15px) translateX(-15px) scale(0.95);
  }
}

.banner-content {
  position: relative;
  z-index: 1;
}

.content-wrapper {
  max-width: 620px;
  padding-left: 0;
  padding-right: 12px;
}
@media (min-width: 1280px) {
  .content-wrapper {
    padding-left: 90px;
    padding-right: 0;
  }
}

@media (min-width: 1600px) {
  .content-wrapper {
    padding-left: 0px;
    padding-right: 0;
  }

  
}

.banner-title {
  font-size: 2.5rem;
  font-weight: 800;
  line-height: 1.1;
  color: #0f172a;
  margin: 0;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.gradient-text {
  background: linear-gradient(135deg, #ff6b35 0%, #ff8c5a 50%, #ff6b35 100%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: inline;
  animation: gradientShift 3s ease infinite;
}

@keyframes gradientShift {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

.animate-slide-up {
  animation: slideUp 0.6s ease-out forwards;
  opacity: 0;
}

.delay-1 {
  animation-delay: 0.1s;
}
.delay-2 {
  animation-delay: 0.2s;
}
.delay-3 {
  animation-delay: 0.3s;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.banner-subtitle {
  font-size: 1.05rem;
  line-height: 1.6;
  color: #334155;
  margin: 0.5rem 0 1.5rem;
  font-weight: 500;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.feature-item {
  display: flex;
  align-items: center;
  font-size: 0.975rem;
  font-weight: 600;
  color: #0f172a;
  padding: 10px 14px;
  background: linear-gradient(
    135deg,
    rgba(255, 107, 53, 0.05),
    rgba(255, 140, 90, 0.03)
  );
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  border: 1px solid rgba(255, 107, 53, 0.1);
  position: relative;
  overflow: hidden;
}

.feature-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 107, 53, 0.1),
    transparent
  );
  transition: left 0.5s ease;
}

.feature-item:hover::before {
  left: 100%;
}

.feature-item:hover {
  background: linear-gradient(
    135deg,
    rgba(255, 107, 53, 0.1),
    rgba(255, 140, 90, 0.06)
  );
  transform: translateX(6px) scale(1.02);
  border-color: rgba(255, 107, 53, 0.2);
  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.1);
}

.feature-icon-wrapper {
  background: white;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(255, 107, 53, 0.15);
  transition: all 0.3s ease;
}

.feature-item:hover .feature-icon-wrapper {
  transform: rotate(360deg) scale(1.1);
  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.25);
}

.feature-text {
  color: #0f172a;
}

.actions-row {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 6px;
}

.explore-btn {
  font-weight: 800;
  letter-spacing: 0.4px;
  padding: 16px 32px !important;
  border-radius: 14px !important;
  text-transform: none;
  font-size: 1.05rem;
  min-width: 220px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.glow-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  transition: left 0.5s ease;
}

.glow-btn:hover::before {
  left: 100%;
}

.glow-btn:hover {
  transform: translateY(-3px) scale(1.02);
  box-shadow: 0 12px 32px rgba(255, 107, 53, 0.45) !important;
}

.glow-btn:active {
  transform: translateY(-1px) scale(0.98);
}

.learn-btn {
  font-weight: 700;
  color: #0f172a;
  text-transform: none;
  padding-left: 8px;
  transition: all 0.3s ease;
}

.learn-btn:hover {
  background: rgba(255, 107, 53, 0.05);
  transform: translateX(4px);
}

.visual-section {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 30px;
  background: linear-gradient(135deg, #fef5f1 0%, #fef8f5 50%, #fff5f0 100%);
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  border-left: 1px solid rgba(255, 107, 53, 0.1);
  position: relative;
}

.visual-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ff6b35' fill-opacity='0.04'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.5;
  pointer-events: none;
}

.cards-stack {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 280px;
}

.package-card {
  background: linear-gradient(135deg, #ffffff 0%, #fffcfb 100%);
  border-radius: 16px;
  padding: 22px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 4px 16px rgba(255, 107, 53, 0.1);
  border: 2px solid rgba(255, 107, 53, 0.12);
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);
  position: relative;
  overflow: hidden;
}

.package-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 107, 53, 0.08),
    transparent
  );
  transition: left 0.6s ease;
}

.package-card:hover::before {
  left: 100%;
}

.package-card:hover {
  transform: translateX(-10px) scale(1.03);
  box-shadow: 0 16px 40px rgba(255, 107, 53, 0.2);
  border-color: rgba(255, 107, 53, 0.3);
}

.featured-card {
  border: 2px solid rgba(255, 107, 53, 0.35);
  box-shadow: 0 8px 28px rgba(255, 107, 53, 0.18);
  background: linear-gradient(135deg, #fffaf8 0%, #fff5f1 100%);
}

.featured-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: linear-gradient(135deg, #ff6b35, #ff8c5a);
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
  animation: badgePulse 2s ease-in-out infinite;
}

@keyframes badgePulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 6px 16px rgba(255, 107, 53, 0.5);
  }
}

.icon-glow {
  background: linear-gradient(135deg, #fff5f0, #ffffff);
  border-radius: 14px;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(255, 107, 53, 0.15);
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);
  position: relative;
}

.icon-glow::before {
  content: "";
  position: absolute;
  inset: -2px;
  border-radius: 14px;
  padding: 2px;
  background: linear-gradient(
    135deg,
    rgba(255, 107, 53, 0.3),
    rgba(255, 140, 90, 0.1)
  );
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.package-card:hover .icon-glow {
  transform: scale(1.15) rotate(8deg);
  box-shadow: 0 8px 28px rgba(255, 107, 53, 0.3);
}

.package-card:hover .icon-glow::before {
  opacity: 1;
}

.card-content {
  flex: 1;
}

.card-title {
  font-weight: 700;
  font-size: 1.1rem;
  color: #0f172a;
  margin-bottom: 4px;
}

.card-subtitle {
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.4;
}

.card-animate {
  animation: slideInRight 0.6s ease-out forwards;
  opacity: 0;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 960px) {
  .visual-section {
    display: none;
  }
  .banner-title {
    font-size: 1.75rem;
  }
  .banner-subtitle {
    font-size: 0.98rem;
  }
  .features-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .banner-title {
    font-size: 1.5rem;
  }
  .explore-btn {
    width: 100%;
    min-width: 0;
  }
  .actions-row {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }
  .learn-btn {
    width: 100%;
  }
}
</style>
